import { render, staticRenderFns } from "./QuestionStem.vue?vue&type=template&id=1603c152&scoped=true&"
import script from "./QuestionStem.vue?vue&type=script&lang=js&"
export * from "./QuestionStem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionStem.vue?vue&type=style&index=0&id=1603c152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603c152",
  null
  
)

export default component.exports